import type { IChatCenterState } from '../../api/domain';
import type { IRootState } from '../root-reducer';

export const getChatCenterState = (state: IRootState): IChatCenterState | undefined => (state && state.chatApi && state.chatApi.chatCenterState) || undefined;
